import {useState} from "react"

// components
import UserList from "./UserList"
import AddUser from "./AddUser"

// styles and images
import '../project/Project.css'
import Add from '../../assets/add.svg'

import {dbDataStore, userStore} from "../../store/Store"

export default function Users() {
    // global state
    const currentUser = userStore(userDataStore => userDataStore.currentUser)
    const users = dbDataStore(data => data.users)
    // triggers
    const [addTrigger,
        setAddTrigger] = useState(false)

    return (
        <div className="container-fluid">
            <div className='d-flex justify-content-between project-header border-bottom'>
                <h2>Users</h2>
                <img
                    src={Add}
                    alt='add'
                    onClick={() => setAddTrigger(true)}
                    className='project-delete-image'/>
            </div>
            <div className="row g-2"></div>
            {(users) && <div className="row g-2">
                <UserList
                    users={users}
                    userRole={currentUser.role_name}/>
            </div>}
            {(addTrigger && currentUser && users) && <AddUser setTrigger={setAddTrigger} users={users}/>}
        </div>
    )
}
